import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { trackById } from '@vex/utils/track-by';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { Router, RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { inject } from '@angular/core';
import { AuthService, guestUser } from 'src/service/auth/auth.service';
import { NavigationLoaderService } from 'src/app/core/navigation/navigation-loader.service';

export interface OnlineStatus {
  id: 'online' | 'away' | 'dnd' | 'offline';
  label: string;
  icon: string;
  colorClass: string;
}

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    NgIf
  ]
})
export class ToolbarUserDropdownComponent implements OnInit {
  private authService: AuthService
  public userFullName$: string
  private userId: number
  public userImageUrl$: string
  public userTitle$: string
  
  
  items: MenuItem[] = [] 

  statuses: OnlineStatus[] = []
  /*  {
      id: 'online',
      label: 'Online',
      icon: 'mat:check_circle',
      colorClass: 'text-green-600'
    },
  ];*/

  activeStatus: OnlineStatus = this.statuses[0];

  trackById = trackById;
  private _navLoaderSvc: NavigationLoaderService;
  private router: Router;

  constructor(
    private cd: ChangeDetectorRef,
    private popoverRef: VexPopoverRef<ToolbarUserDropdownComponent>
  ) {
      this.authService = inject(AuthService);
      this._navLoaderSvc = inject(NavigationLoaderService)
      this.router = inject(Router);
      this.userFullName$ = this.authService.loggedInUser.fullName;
      this.userId = this.authService.loggedInUser.id 
      this.userImageUrl$ = "../../../../assets/img/avatars/" + this.userId + ".jpg"
      this.userTitle$ = this.authService.loggedInUser.title

  
  }

  ngOnInit() {
    this.items.push(    {
      id: '1',
      icon: 'mat:notifications',
      label: 'No Notifications',
      description: 'No New Notifications',
      colorClass: 'text-teal-600',
      route: this.router.url
    },)
  }

  setStatus(status: OnlineStatus) {
    this.activeStatus = status;
    this.cd.markForCheck();
  }

  close() {
    this._navLoaderSvc.loadNavigation();
    this.router.navigate(['/login']);
    this.popoverRef.close();
  }
  logout() {
    this.authService.logOutUser().subscribe({
      next: (response) => {
        console.log("Logout response: ", response)
        if (response) {
          this.authService.loggedInUser = guestUser;
          localStorage.removeItem("loggedInUser")
        } else {
          console.error("Logout failed");
        }
        console.log ("logout called")
        this.close()  
      },
      error: (error) => {
        console.error("Error during logout: ", error);
        console.log ("logout error called")
        this.close()  
      }
  
    });
  }
}
